export default __webpack_public_path__ + "static/media/employeeBenefits.cd04de2a.jpg";